/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Import_Error_BuildingInputs */



/**
* | output |
* | --- |
* | "Building ID does not match the intervention" |
*
* @param {Intervention_Plan_Import_Error_BuildingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_import_error_building = /** @type {((inputs?: Intervention_Plan_Import_Error_BuildingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Import_Error_BuildingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Building ID does not match the intervention")
	return /** @type {LocalizedString} */ ("L'identifiant du bâtiment ne correspond pas à celui de l'intervention")
});